<script lang="ts">
  import { t } from '../i18n/index';
  import { appState } from '../state.svelte';

  let {
    onSave,
    onCancel,
  }: {
    onSave: (payload: { name: string; email: string | null }) => void;
    onCancel: () => void;
  } = $props();

  let name = $state(appState.visitor.name);
  let email = $state(appState.visitor.email ?? '');
  let localError = $state(null as string | null);

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function handleSave(event: SubmitEvent) {
    event.preventDefault();
    localError = null;
    const trimmedName = name.trim();
    if (!trimmedName) {
      localError = t('visitor.nameRequired');
      return;
    }
    const trimmedEmail = email.trim();
    if (trimmedEmail && !EMAIL_RE.test(trimmedEmail)) {
      localError = t('visitor.invalidEmail');
      return;
    }
    onSave({ name: trimmedName, email: trimmedEmail || null });
  }
</script>

<div
  class="tashimoto-support-absolute tashimoto-support-inset-0 tashimoto-support-bg-black/40 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center tashimoto-support-z-50"
  data-testid="edit-profile-modal"
>
  <form
    class="tashimoto-support-bg-white tashimoto-support-rounded-xl tashimoto-support-shadow-2xl tashimoto-support-w-[85%] tashimoto-support-max-w-[320px] tashimoto-support-p-5 tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-3"
    onsubmit={handleSave}
  >
    <h3 class="tashimoto-support-text-base tashimoto-support-font-semibold tashimoto-support-text-gray-900">
      {t('editProfile.title')}
    </h3>

    <label class="tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-1">
      <span class="tashimoto-support-text-xs tashimoto-support-font-medium tashimoto-support-text-gray-700">
        {t('editProfile.nameLabel')}
      </span>
      <input
        type="text"
        bind:value={name}
        class="tashimoto-support-border tashimoto-support-rounded-lg tashimoto-support-px-3 tashimoto-support-py-2 tashimoto-support-text-sm"
        data-testid="edit-profile-name"
      />
    </label>

    <label class="tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-1">
      <span class="tashimoto-support-text-xs tashimoto-support-font-medium tashimoto-support-text-gray-700">
        {t('editProfile.emailLabel')}
      </span>
      <input
        type="email"
        bind:value={email}
        class="tashimoto-support-border tashimoto-support-rounded-lg tashimoto-support-px-3 tashimoto-support-py-2 tashimoto-support-text-sm"
        data-testid="edit-profile-email"
      />
    </label>

    {#if localError}
      <p class="tashimoto-support-text-sm tashimoto-support-text-red-600" role="alert">
        {localError}
      </p>
    {/if}

    <div class="tashimoto-support-flex tashimoto-support-gap-2 tashimoto-support-mt-2">
      <button
        type="button"
        class="tashimoto-support-flex-1 tashimoto-support-py-2 tashimoto-support-text-sm tashimoto-support-bg-gray-100 hover:tashimoto-support-bg-gray-200 tashimoto-support-rounded-lg"
        onclick={onCancel}
      >
        {t('common.cancel')}
      </button>
      <button
        type="submit"
        class="tashimoto-support-flex-1 tashimoto-support-py-2 tashimoto-support-text-sm tashimoto-support-text-white tashimoto-support-bg-blue-500 hover:tashimoto-support-bg-blue-600 tashimoto-support-rounded-lg"
        data-testid="edit-profile-save"
      >
        {t('editProfile.save')}
      </button>
    </div>
  </form>
</div>
